module.exports = __webpack_public_path__ + "54cf98f5/img/upload-icon.9179ae4e.svg";